module.exports = __webpack_public_path__ + "static/media/step4-healthy-food-delivery.1b5d6011.png";